import React, { useState, useCallback, useEffect, useRef, useMemo } from "react";
import { connect } from "react-redux";
import FormField from '../../../../../../dynamicFormBuilder/FormField'
import { AdditionalLayout, AlternateSKULayout, CommentLayout, UserDefinedLayout } from './Layout';

function AlternateSKUTab(props) {
    var currentUser = props.oidc.user;
    const DYNAMICFORMSETTING = props.oidc?.user?.profile?.DYNAMICFORMSETTING;
    const formRefs = useRef({});


    const handleAdditionalFormLoad = useCallback(() => {

    }, []);
    const handleFieldChange = useCallback((name, value, e) => {

    }, []);
    const handleSelectionChange = useCallback((name, value, e) => {

    }, []);

    return (
        <div style={{ height: '100%', overflow: 'auto' }}>
            <FormField
                currrentUser={currentUser}
                layoutId='B31871DE-E136-47D7-AD3E-FBAF6BFED43B'
                layoutName='OMAlternateSKUForm'
                defaultFormSchema={AlternateSKULayout}
                formFields={props.formFields}
                setformFields={props.setformFields}
                handleFieldValueChange={handleFieldChange}
                DYNAMICFORMSETTING={DYNAMICFORMSETTING}
                formRefs={formRefs}
                onFormLoad={handleAdditionalFormLoad}
                handleSelectedItemChange={handleSelectionChange}
            />

        </div>
    );
}
function mapStateToProps(state) {
    return {
        ReceiptReducer: state.ReceiptReducer,
        oidc: state.oidc,
    };
}
export default connect(mapStateToProps)(AlternateSKUTab);
